import { ROUTES } from "@/types/routes";
import type { NavigationPolicy } from "../../../navigation.types";

/** template2 = supergol：Tab 根页与 template1 相同；左下浮标按后台配置贴左；页面层自滚动 */
export const navigationPolicy: NavigationPolicy = {
  tabRootRoutes: [
    ROUTES.HOME,
    ROUTES.HOME_ALT,
    ROUTES.EVENT_CENTER,
    ROUTES.PROFILE,
    ROUTES.AGENT_CENTER,
    ROUTES.INVITE_FRIENDS,
  ],
  hideBackRoutes: [ROUTES.INVITE_FRIENDS, ROUTES.EVENT_CENTER],
  // 活动中心 template2（六 Tab 版）自带头部，不要 PageWrapper 顶栏
  // 搜索页 / 分类页自绘竞品顶栏（SgPageHeader），不要 PageWrapper 顶栏
  navbarlessRoutes: [
    ROUTES.HOME,
    ROUTES.HOME_ALT,
    ROUTES.EVENT_CENTER,
    ROUTES.GAME_SEARCH,
    ROUTES.GAME_CATEGORY,
    ROUTES.MESSAGE_CENTER,
    ROUTES.SECURITY_CENTER,
    ROUTES.SECURITY_VERIFY_PASSWORD,
    ROUTES.SECURITY_CHANGE_PASSWORD,
    ROUTES.SECURITY_BIND_EMAIL,
    ROUTES.RECORDS_DEPOSIT,
    ROUTES.PAY_RECORDS,
    ROUTES.AUDIT_DETAIL,
    // 充值 / 提现整页自带头块（竞品 /recharge/apply、/withdraw/apply：无底栏、右上 ✕ 返回）
    ROUTES.RECHARGE,
    ROUTES.WITHDRAW,
    // 竞品 /activity/vip 二级页：自绘顶栏（SgPageHeader + 右上记录钮），无底栏
    ROUTES.VIP,
    // 累计充值奖励：页面自绘与 VIP 同款的 SgPageHeader
    ROUTES.CUMULATIVE_RECHARGE,
    // 红包雨（新）活动页：页面自绘同款 SgPageHeader（2026-10-18 按竞品 Mina Misteriosa 重做）
    ROUTES.RED_ENVELOPE_RAIN,
  ],
  // 左侧浮标（客服等）完全按后台「左下浮标」配置渲染，位置/尺寸由 navigation template2 样式接管
  hideBackendCustomFloatIcons: false,
  floatIconsPlacement: "left",
  ownScrollLayers: true,
  loadingStyle: "ionicBubbles",
  // 竞品 Perfil 必须登录，未登录点底栏 / 直接访问都拉起登录弹层
  loginRequiredRoutes: [
    ROUTES.PROFILE,
    ROUTES.SECURITY_CENTER,
    ROUTES.SECURITY_VERIFY_PASSWORD,
    ROUTES.SECURITY_CHANGE_PASSWORD,
    ROUTES.SECURITY_BIND_EMAIL,
    ROUTES.PAY_RECORDS,
    ROUTES.AUDIT_DETAIL,
    ROUTES.RECHARGE,
    ROUTES.WITHDRAW,
  ],
  pageTitleKeyOverrides: { [ROUTES.GAME_SEARCH]: "navigation.sg.search" },
};
